import styled from "styled-components";

const getColor = (props: { contentColor?: string; theme: any }) => {
  if (props.contentColor === "primary") {
    return props.theme.colors.primary;
  }
  return props.contentColor || props.theme.colors.contentTxt;
};

export const MemoHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const MemoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: ${(props) => props.theme.colors.primary};
  border-radius: 3px;

  svg {
    fill: white;
    stroke: white;
  }
`;

export const MemoLabel = styled.span<any>`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.contentLabelTxt};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.3rem")};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MemoContent = styled.div<{ contentColor?: string }>`
  color: ${(props) => getColor(props)};
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  white-space: pre-line;
  word-break: keep-all;
`;

export const ItemMemoBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  width: 100%;
  background: ${(props) => props.theme.colors.black4};
  border-radius: 4px;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;

  svg {
    flex-shrink: 0;
  }

  p {
    display: flex;
    min-height: 20px;
    color: ${(props) => props.theme.colors.black80};
    font-size: 1.3rem;
    line-height: 160%;
    flex-wrap: wrap;
    align-items: center;
  }
`;
